export default {
  addCurriculumUrl: ({ commit }, payload) => commit('ADD_CURRICULUM_URL', payload),
  clearCurriculumState: ({ commit }) => commit("CLEAR_CURRICULUM_STATE"),
}